import { CoverageGroupResponse } from "../../../../../../../../services/cloudchipr.api";

export type HighChartsCoverageWidgetTotals = Map<
  string,
  {
    amount: number;
    percentage: number;
  }
>;

export const generateHighChartsTotalCostsFromCoverage = (
  data?: CoverageGroupResponse[],
) => {
  return data?.reduce((result, item, index) => {
    const key = index.toString();

    const totalCost =
      (item?.savings_plan?.amount ?? 0) + (item?.reservation?.amount ?? 0);
    const totalPercent =
      (item?.savings_plan?.percentage ?? 0) +
      (item?.reservation?.percentage ?? 0);

    result.set(key, {
      amount: totalCost,
      percentage: totalPercent,
    });

    return result;
  }, new Map() as HighChartsCoverageWidgetTotals);
};
